<template>
    <client-page>
        <v-sheet class="about-visual white--text image-card" style="background-image:url(/images/sub/about/about-visual-bg.jpg)">
            <v-container>
                <div>
                    <h2 class="font-size-40 font-size-md-52 font-size-lg-72 line-height-13 mb-8 mb-lg-16">
                        <span class="font-weight-regular">MICE 채용을 위한 <br>
                        가장 편리한 플랫폼 </span>MICEPEC
                    </h2>
                    <p class="page-text--lg">
                        마이스펙은 MICE산업 유일한 채용플랫폼으로 기업 채용관리 및 DB구축, 개인 지원서 및 경력관리에 이르는 <br class="d-none d-md-block">
                        MICE 채용 전반에 걸친 서비스를 제공합니다.
                    </p>
                </div>
            </v-container>
        </v-sheet>
        <!-- <service-visual /> -->

        <v-sheet class="service-banner py-50 py-lg-90">
            <v-container>
                <v-row align="center" class="flex-md-row-reverse">
                    <v-col cols="12" md="6" class="mb-16 mb-md-0">
                        <div class="service-banner__img">
                            <v-img src="/images/sub/service/service-img.png" class="w-100" />
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <h3 class="tit tit--lg line-height-13 white--text mb-8 mb-lg-16">
                            <span style="color: #FFE810">모집부터 접수까지 한번에</span> <br>
                            마이스펙 공고 링크를 <br>
                            다양한 플랫폼에 올려보세요
                        </h3>
                        <p class="page-text page-text--lg white--text">
                            지원자의 정보를 한눈에 볼 수 있는 것은 물론 마이스펙 인증 경력까지 <br class="d-none d-lg-block">
                            확인할 수 있어 보다 효과적으로 채용매칭율을 높일 수 있습니다
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </v-sheet>

        <section class="sub-section">
            <v-container>
                <v-row class="kaban-contents flex-md-row-reverse">
                    <v-col cols="12" md="6" xl="9" offset-xl="3" class="mb-16 mb-md-0">
                        <v-img src="/images/sub/service/service-img2.png" max-width="932" class="mx-auto mr-md-0" />
                    </v-col>
                    <v-col cols="12" md="6" class="kaban-contents__txt">
                        <h3 class="tit tit--lg line-height-13 mb-8 mb-lg-16">
                            지원자 칸반보드로 <br>
                            한눈에 들어오는 채용현황
                        </h3>
                        <p class="page-text page-text--lg grey--text word-keep-all">
                            채용단계를 직접 설정할 수 있고, 지원자별 자유로운 이동이 가능하기에 <br class="d-none d-xl-block">
                            모든 채용과정을 쉽게 관리할 수 있습니다
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <v-row no-gutters>
            <v-col cols="12" sm="6">
                <v-layout column align-center class="w-100 h-100 px-12 py-50 py-lg-90 text-center image-card" style="background-image: url(/images/sub/service/service-img3-1.jpg)">
                    <h3 class="tit line-height-1 white--text mb-20 mb-lg-40">
                        먼저 사용해보세요
                    </h3>
                    <v-layout>
                        <v-btn color="white" class="primary--text min-w-140px min-w-lg-160px mx-4" @click="showFreeTrial">무료체험하기</v-btn>
                        <!-- <v-btn color="white" outlined class="min-w-140px min-w-lg-160px mx-4">사용가이드 보기</v-btn> -->
                    </v-layout>
                </v-layout>
            </v-col>
            <v-col cols="12" sm="6">
                <v-layout column align-center class="w-100 h-100 px-12 py-50 py-lg-90 text-center image-card" style="background-image: url(/images/sub/service/service-img3-2.jpg)">
                    <h3 class="tit line-height-1 white--text mb-20 mb-lg-40">
                        솔루션 상담을 받아보세요+
                    </h3>
                    <v-btn to="/center/inquiry" color="white" class="primary--text min-w-140px min-w-lg-160px">문의하기</v-btn>
                </v-layout>
            </v-col>
        </v-row>

        <section class="sub-section">
            <v-container>
                <div class="mb-40 mb-lg-100 text-center">
                    <h3 class="tit tit--lg line-height-13 mb-8 mb-lg-16">
                        소통이 편해지면 채용도 쉬워집니다
                    </h3>
                    <p class="page-text page-text--lg grey--text word-keep-all">
                        이제 마이스펙 하나로 바꿔보세요
                    </p>
                </div>
                <v-row>
                    <v-col v-for="item in service" :key="item.title" cols="12" sm="6" md="4">
                        <v-card elevation="0" color="grey-f7" rounded="lg" class="h-100">
                            <v-layout column justify-space-between class="w-100 h-100">
                                <div class="pa-20 pa-md-30 pa-lg-40">
                                    <h4 class="tit--sm primary--text line-height-1 mb-6 mb-lg-12">
                                        {{item.title}}
                                    </h4>
                                    <p v-html="item.sc" class="page-text line-height-15 grey--text word-keep-all"></p>
                                </div>
                                <div class="pl-20 pl-md-30 pl-lg-40">
                                    <v-img :src="item.image" max-width="372" class="ml-auto" />
                                </div>
                            </v-layout>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="sub-section sub-section--link image-card" style="background-image:url(/images/sub/service/service-img5.jpg)">
            <v-container>
                <h3 class="tit tit--lg font-size-lg-56 line-height-13 text-center mb-20 mb-lg-40">
                    소통이 편해지면 채용도 쉬워집니다
                </h3>
                <v-layout justify-center>
                    <v-btn color="primary" class="min-w-140px min-w-lg-160px mx-4" @click="showFreeTrial">무료체험하기</v-btn>
                    <v-btn to="/center/inquiry" color="white" class="primary--text min-w-140px min-w-lg-160px mx-4">문의하기</v-btn>
                </v-layout>
            </v-container>
        </section>

        <dialog-join ref="dialog-join" />

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import ServiceVisual from "@/components/client/service/service-visual.vue";
import DialogJoin from "@/components/client//join/dialog-join/dialog-join.vue";
import { mapGetters } from "vuex";


export default {
    components: {
        ClientPage,
        ServiceVisual,
        DialogJoin,
    },
    data: () => ({
        service: [
            {
                title: "사전질문기능",
                sc: "사전 질문 기능을 통해 지원자의 일정, 언어유무, 상세경력 등을 자세히 물어보세요",
                image: "/images/sub/service/service-img4-1.png",
            },
            {
                title: "통합관리 기능",
                sc: "모든 채용 플랫폼 지원하기 방식을 홈페이지 지원으로 변경하고 링크만 넣어 지원자를 통합관리하세요",
                image: "/images/sub/service/service-img4-2.png",
            },
            {
                title: "DB 관리하기",
                sc: "프로젝트별 지원자는 물론 누적된 근무자의 통합관리를 통해 귀사만의 DB를 구축하세요",
                image: "/images/sub/service/service-img4-3.png",
            },
            {
                title: "지원자 연락",
                sc: "반복되는 공지사항 전달 이제 마이스펙 문자템플릿을 통해 쉽고 간편하게 전송하세요",
                image: "/images/sub/service/service-img4-4.png",
            },
            {
                title: "일정 조율",
                sc: "지원자와의 면접 스케쥴 조정 쉽고 빠르게 확인하세요",
                image: "/images/sub/service/service-img4-5.png",
            },
            {
                title: "메모 기능",
                sc: "지원자의 특이사항 이제 따로 정리하시고 <br class='d-none d-lg-block' />마이스펙에 메모하세요",
                image: "/images/sub/service/service-img4-6.png",
            },
        ],
    }),
    props: {
    },
    computed: {
        ...mapGetters(["isUserLoggedIn"])
    },
    mounted() {
    },
    methods: {
        showFreeTrial() {
            if(this.isUserLoggedIn) window.open('./dashboard', '_self');
            else this.$refs['dialog-join'].shows = true;
        }
    },
};
</script>

<style lang="scss" scoped>
.sub-section{
    padding: 80px 0;
}
.container{
    max-width: calc(var(--container-lg) + 24px);
}
.about-visual{
    height: 400px ;
    .container{
        height: 100%;
        display: flex;
        align-items: center;
        background-image: url(/images/sub/about/about-visual.svg);
        background-position: right center;
        background-repeat: no-repeat;
        background-size: auto 100%;
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
    .sub-section{
        padding: 120px 0;
    }
    .about-visual{
        height: 480px ;
    }
}
@media (min-width:1024px){
    .sub-section{
        padding: 160px 0;
    }   
    .about-visual{
        height: 600px ;
    }
}
@media (min-width:1200px){
}

.service-banner{
    background-color: #4629a0;
    &__img{
        width: 100%;
        max-width: 578px;
        margin-left: auto;
        margin-right: auto;
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
    .service-banner{
        &__img{
            margin-right: 0;
            position: relative;
            &::before{
                content: "";
                position: absolute;
                display: block;
                width: 300px;
                height: 300px;
                top: -24px;
                left: -120px;
                background-position: left top;
                background-repeat: no-repeat;
                background-size: contain;
                background-image: url(/images/sub/service/service-obj.svg);
            }
        }
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
    .service-banner{
        &__img{
            &::before{
                width: 390px;
                height: 434px;
                top: -36px;
                left: -154px;
            }
        }
    }
    .kaban-contents{
        position: relative;
        &__txt{
            z-index: 3;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
}
.sub-section--link{
    min-height: 760px;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .sub-section--link{
        min-height: 980px;
    }
}
@media (min-width:1200px){
}

</style>